<template>
  <div class="flex py-2">
    <button
      v-for="col in columns" :key="'sorter' + col.name"
      class="outline-0 border-0 shadow-0 h-4 flex items-center mx-1 "
      :class="col.classes"
      @click="sort(col.name)">
      <span class="flex w-8 justify-center align-center">
        <i :class="returnClass(col.name)" />
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ListSorter',
  props: {
    columns: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      selectedCol: null,
      direction: 0
    }
  },
  methods: {
    returnClass (col) {
      let classes = 'text-gray-200 '
      if (col === this.selectedCol) {
        classes = 'text-primary '
      } else {
        return classes + 'icon-select'
      }
      if (this.direction > 0) {
        classes += 'icon-sort-az'
      } else if (this.direction < 0) {
        classes += 'icon-sort-za'
      } else {
        classes += 'icon-select'
      }
      return classes
    },
    sort (column) {
      if (this.selectedCol === column) {
        if (this.direction === -1) {
          this.selectedCol = null
          this.direction = 0
          return
        }
        this.direction = this.direction < 0 ? 1 : -1
      } else {
        this.selectedCol = column
        this.direction = 1
      }
      this.$emit('changed', {
        column,
        direction: this.direction
      })
    }
  }
}
</script>

<style scoped>
button:active, button:focus {
  border: 0 !important;
  border-style: none;
  outline: none !important;
}
</style>
